var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sort"},[_c('div',{staticClass:"sort-item",class:{
    'is-active': !_vm.sortName
  },on:{"click":_vm.handleClear}},[_c('span',{staticClass:"text"},[_vm._v("综合排序")])]),_vm._v(" "),_vm._l((_vm.sortColumns),function(sort,index){return _c('div',{key:sort.name,staticClass:"sort-item",class:{
    'is-active': sort.name === _vm.sortName
  }},[_c('span',{staticClass:"text",on:{"click":function($event){return _vm.onOrderClick(sort, index)}}},[_vm._v("\n      "+_vm._s(sort.text)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"caret-wrapper",class:[
      sort.name === _vm.sortName
        ? _vm.sortType == '4'
          ? 'ascending'
          : 'descending'
        : ''
    ]},[_c('i',{staticClass:"sort-caret ascending"}),_vm._v(" "),_c('i',{staticClass:"sort-caret descending"})])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }